module.exports = __webpack_public_path__ + "img/trainings.7307c742.png";